






















import { Component, Ref, Prop, Provide, ProvideReactive, Vue, Watch } from "vue-property-decorator"
import jQuery from "jquery"
import RestClient from "./components/RestClient.vue"
import ConfirmDialog from "./components/ConfirmDialog.vue"
import Navigation from "./components/Navigation.vue"
import Version from "./version"
import Settings from "./settings"
import Auth from "./auth"
import GoogleAuth from "./auths/google"
import LINEAuth from "./auths/line"
import Account from "./account"
import { getCookie, setCookie, deleteCookie } from "./cookie"
const accessTokenCookie = '_osl_access_token'

@Component({
    components: {
        RestClient,
        ConfirmDialog,
        Navigation,
    }
})
export default class App extends Vue {
    $log: any
    $t: any
    @ProvideReactive() @Ref("restClient") readonly restClient!: RestClient
    @Ref("confirmDialog") readonly confirmDialog!: ConfirmDialog
    @ProvideReactive() version?: Version
    @ProvideReactive() settings?: Settings
    @ProvideReactive() auths: Auth[] = []
    @ProvideReactive() account?: Account
    data() {
        return {
            version: null,
            settings: null,
            auth: null,
            account: null,
        }
    }
    mounted() {
        this.restClient.error = (uuid: string, s: JQueryAjaxSettings,xhr: JQueryXHR, status: string, ex: string): boolean => {
            if (xhr.status == 401) {
                deleteCookie(accessTokenCookie)
                this.restClient.token = undefined
                this.account = undefined
                let reload = {
                    text: this.$t('re_login'),
                    action: () => {
                        this.$router.push({name: 'login', params: {redirect: this.$route.path}})
                    }
                }
                let close = {
                    text: this.$t('close'),
                    action: () => {}
                }
                this.confirmDialog.show(undefined, this.$t('permission_denied'), reload, close)
            } else {
                this.onError(this.$t('api_error', {code: xhr.status, status: xhr.statusText}), JSON.stringify(s), uuid)
            }
            return true
        }
        this.restClient.request("GET", "/v1/environment", null, env => {
            this.version = Version.unmarshal(env.version)
            this.settings = Settings.unmarshal(env.settings)
        })
        let token = getCookie(accessTokenCookie)
        if (token) {
            this.restClient.token = token
            this.restClient.request("GET", "/v1/accounts", null, (json: any) => {
                this.account = Account.unmarshal(json)
            })
        }
    }
    onError(message: string, detail: string, request_id?: string) {
        var error = {
            message: message,
            detail: detail,
            request_id: request_id,
        }
        let option = {
            text: this.$t('report_error'),
            action: () => {
                this.restClient.request("POST", "/v1/error_reports", error, data => {
                    this.confirmDialog.show("", this.$t('report_error_submitted'))
                })
            }
        }
        this.confirmDialog.show(this.$t('oops'), message, option)
    }
    @Watch('settings')
    init() {
        if (this.settings) {
            var auths = []
            auths.push(new GoogleAuth(this.settings.google_client_id, this.restClient))
            auths.push(new LINEAuth(this.settings.line_client_id, this.restClient))
            this.auths = auths
        }
    }
    get getVersion() {
        if (this.version) {
            if (this.version.tag) {
                return this.version.tag
            } else if (this.version.commit) {
                return '('+this.version.commit+')'
            }
        }
        return '(development version)'
    }
    getAccount(auth: string, credential: any) {
        this.restClient.request("POST", "/v1/accounts?auth=" + auth, credential, (json: any) => {
            this.account = Account.unmarshal(json)
            if (json.token) {
                this.restClient.token = json.token
                setCookie(accessTokenCookie, json.token)
            }
            if (json.session) {
                if (json.session.redirect) {
                    this.$router.push(json.session.redirect)
                }
            }
        })
    }
    signOut() {
        deleteCookie(accessTokenCookie)
        this.account = undefined
        this.$router.push('/')
    }
}
